/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Select_FileInputs */

const vi_tea_purchase_payment_proof_select_file = /** @type {(inputs: Tea_Purchase_Payment_Proof_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn file`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Select_FileInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_select_file = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Select_FileInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Select_FileInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_select_file(inputs)
});